import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=74d3fc3b&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=74d3fc3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d3fc3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d3fc3b')) {
      api.createRecord('74d3fc3b', component.options)
    } else {
      api.reload('74d3fc3b', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=74d3fc3b&scoped=true&", function () {
      api.rerender('74d3fc3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2z7mDl3Ft0fRj/JS/comp/PopupBox.vue"
export default component.exports